import { render, staticRenderFns } from "./card-form.vue?vue&type=template&id=4f03d658&"
import script from "./card-form.vue?vue&type=script&lang=js&"
export * from "./card-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports